/**
 * fetch APIによるHTTPリクエストを管理するStateを扱うモジュール
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

enum ActionTypes {
  BEGIN = 'app/fetch/BEGIN',
  CANCEL = 'app/fetch/CANCEL',
  END = 'app/fetch/END',
  FAILED = 'app/fetch/FAILED'
}

export enum FetchStatus {
  // 処理中
  PROCESSING,
  // キャンセル
  CANCEL,
  // 未処理
  UNTREATED,
  // エラー終了
  FAILED
}

/**
 * fetch開始のActionを作成する
 * @param {string} payload 識別するためのリクエストID
 */
export const beginFetch = (payload: string) =>
  createAction(ActionTypes.BEGIN, payload);

/**
 * fetchをキャンセルするActionを作成する
 * @param {string} payload キャンセルするリクエストのリクエストID
 */
export const cancelFetch = (payload: string) =>
  createAction(ActionTypes.CANCEL, payload);

/**
 * fetch終了のActionを作成する
 * @param payload 終了したリクエストのリクエストID
 */
export const endFetch = (payload: string) =>
  createAction(ActionTypes.END, payload);

/**
 * fetchエラー終了のActionを作成する
 * @param payload エラー終了したリクエストのリクエストID
 */
export const failedFetch = (payload: string) =>
  createAction(ActionTypes.FAILED, payload);

const actions = {
  beginFetch,
  cancelFetch,
  endFetch,
  failedFetch
};

type fetchAction = ActionsUnion<typeof actions>;

/** Fetch APIによるHTTPリクエストのState */
export interface FetchState {
  /**
   * 各リクエストの状態。キーにリクエストID、値にFetchの状態を持つ。
   */
  [key: string]: FetchStatus | string;
}

const initialState: FetchState = {};

export default (
  state: FetchState = initialState,
  actions: fetchAction
): FetchState => {
  switch (actions.type) {
    case ActionTypes.BEGIN:
      // 非同期でdispatchされるとCANCELが先に来るケースがあるので
      // 既にCANCELのRequestIDが存在する場合は状態をBEGINに上書きしない
      if (state[actions.payload as string] === FetchStatus.CANCEL) {
        return state;
      }
      return {
        ...state,
        [actions.payload as string]: FetchStatus.PROCESSING
      };
    case ActionTypes.CANCEL:
      if (
        state[actions.payload] === FetchStatus.UNTREATED ||
        state[actions.payload] === FetchStatus.FAILED
      ) {
        // 既にUNTREATEDまたはFAILEDになっているならば、変更しない
        return state;
      }
      return {
        ...state,
        [actions.payload as string]: FetchStatus.CANCEL
      };
    case ActionTypes.END:
      return {
        ...state,
        [actions.payload as string]: FetchStatus.UNTREATED
      };
    case ActionTypes.FAILED:
      return {
        ...state,
        [actions.payload as string]: FetchStatus.FAILED
      };
    default:
      return state;
  }
};
